import { ClientJS } from 'clientjs'
import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import { recaptchaKey } from 'configs'
import { checkInputType, getMetaContent, validateEmail } from 'helpers'
import useEnterSubmit from 'hooks/useEnterSubmit'
import useRecaptchaV3 from 'hooks/useRecaptchaV3'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { Sheet } from 'react-modal-sheet'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Input, Modal, Spinner } from 'reactstrap'
import { URL_LOGIN_PASSWORD } from 'utils/pathUrl'
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid'
import {
  useCheckDeviceV2Mutation,
  useCreateDeviceMutation,
  useLazyCheckDeviceV1Query,
  usePrecheckLoginMutation,
  useSendOtpLoginMutation,
} from '../login-new/loginNewApiSlice'
import { logout } from 'features/public-views/login/loginSlice'
import './login-universal.css'
import Tnc from './Tnc'
import whatsApp from 'assets/icons/WhatsApp.png'

function ModalContent({
  rightLabel,
  leftLabel,
  onPressRight,
  onPressLeft,
  loading,
  isEmail,
}) {
  return (
    <div>
      <P bold size="medium">
        {isEmail ? 'Email' : 'Nomor'} belum terdaftar
      </P>
      <P style={{ marginTop: 10 }}>
        Daftarkan akun Anda dengan {isEmail ? 'email' : 'nomor'} ini?
      </P>
      {leftLabel ? (
        <div className="d-flex gap-2 mt-4">
          <CustomButton
            onClick={onPressLeft}
            color="secondary"
            className="btn-sm-block me-1 w-100"
            outline
            style={{ borderColor: '#D0D5DD' }}
            disabled={loading}
            testId="login-universal-register-modal-cancel-button"
          >
            {leftLabel}
          </CustomButton>
          <CustomButton
            color="primary"
            className="btn-sm-block ms-1 w-100"
            onClick={onPressRight}
            disabled={loading}
            testId="login-universal-register-modal-confirm-button"
          >
            {rightLabel}
          </CustomButton>
        </div>
      ) : (
        <Button
          className="w-100 mt-4"
          color="primary"
          onClick={onPressRight}
          disabled={loading}
          data-testid="login-universal-register-modal-confirm-button"
        >
          <P>{rightLabel}</P>
        </Button>
      )}
    </div>
  )
}

function ResponsiveModal({
  isMobile,
  onPressRight,
  isOpen,
  onPressLeft,
  loading,
  isEmail,
}) {
  return isMobile ? (
    <Sheet
      isOpen={isOpen}
      snapPoints={[220, 0]}
      onClose={onPressLeft}
      data-testid="login-universal-register-modal"
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content style={{ padding: 15 }}>
          <ModalContent
            rightLabel={'Daftar sekarang'}
            onPressRight={onPressRight}
            loading={loading}
            isEmail={isEmail}
          />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={onPressLeft} />
    </Sheet>
  ) : (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      centered
      style={{ borderRadius: 90, border: 'none' }}
      data-testid="login-universal-register-modal"
    >
      <div style={{ padding: 20 }}>
        <ModalContent
          rightLabel={'Daftar'}
          leftLabel={'Kembali'}
          onPressRight={onPressRight}
          onPressLeft={onPressLeft}
          loading={loading}
          isEmail={isEmail}
        />
      </div>
    </Modal>
  )
}

const Login = () => {
  const { enqueueSnackbar } = useSnackbar()
  const recaptcha = useRecaptchaV3(recaptchaKey)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const params = new URLSearchParams(window.location.search)
  const { token } = useSelector((s) => s.auth)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [loading, setLoading] = useState('')
  const [preCheck, { isLoading: isLoadingPreCheck }] =
    usePrecheckLoginMutation()
  const [sendOtp, { isLoading: isLoadingSendOTP }] = useSendOtpLoginMutation()
  const [suggestions, setSuggestions] = useState([])
  const [isShowRegistModal, setShowRegistModal] = useState({
    modal: false,
    otp: false,
  })
  const [payload, setPayload] = useState({})
  const [userData, setUserData] = useState({})
  const [isFetchingOtp, setIsFetchingOtp] = useState(false)

  const [isMobile, setIsMobile] = useState(false)
  const [isEmail, setIsEmail] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [isOnboard, setIsOnboard] = useState(false)
  const [showCustomSuggest, setShowCustomSuggest] = useState(true)

  const searchParams = new URLSearchParams(window.location.search)

  const getFromLocalStorage = (key, paramKey) => {
    const paramValue = searchParams.get(paramKey)
    if (paramValue) {
      localStorage.setItem(key, paramValue)
      return paramValue
    }
    return localStorage.getItem(key)
  }

  const [hash, setDeviceHash] = useState(() =>
    getFromLocalStorage('PMB_deviceHash', 'deviceHash'),
  )
  const [fcmToken, setFcmToken] = useState(() =>
    getFromLocalStorage('PMB_fcmToken', 'fcmToken'),
  )
  const [mobileVersion, setMobileVersion] = useState(() =>
    getFromLocalStorage('PMB_mobileVersion', 'mobileVersion'),
  )
  const [packageName, setPackageName] = useState(() =>
    getFromLocalStorage('PMB_packageName', 'packageName'),
  )

  useEffect(() => {
    setDeviceHash(getFromLocalStorage('PMB_deviceHash', 'deviceHash'))
    setFcmToken(getFromLocalStorage('PMB_fcmToken', 'fcmToken'))
    setMobileVersion(getFromLocalStorage('PMB_mobileVersion', 'mobileVersion'))
    setPackageName(getFromLocalStorage('PMB_packageName', 'packageName'))
  }, [])

  useEffect(() => {
    const checkScreenSize = () => {
      const isMobileUA =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      const isSmallScreen = window.innerWidth < 768
      setIsMobile(isMobileUA || isSmallScreen)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const [createDevice, resultCreateDevice] = useCreateDeviceMutation()
  const [checkDeviceV1] = useLazyCheckDeviceV1Query()
  const [checkDeviceV2] = useCheckDeviceV2Mutation()

  const publicVersion = useSelector((s) => s.publicVersion)
  const noCsPasmik = process.env.REACT_APP_WA_BOT_NUMBER || publicVersion?.data?.csNumber

  const [identityList, setIdentityList] = useState([])
  const [filteredIdentityList, setFilteredIdentityList] = useState([])

  useEffect(() => {
    const storedNumbers = JSON.parse(localStorage.getItem('identity')) || []
    setIdentityList(storedNumbers)
    setFilteredIdentityList(storedNumbers.slice(0, 5))
  }, [])

  const savePhoneNumberToLocalStorage = (number) => {
    let storedNumbers = JSON.parse(localStorage.getItem('identity')) || []

    storedNumbers = storedNumbers.filter((num) => num !== number)
    storedNumbers.unshift(number)

    localStorage.setItem('identity', JSON.stringify(storedNumbers))
    setIdentityList(storedNumbers)
    setFilteredIdentityList(storedNumbers.slice(0, 5))
  }

  const handleInputChange = (e) => {
    let value = typeof e === 'string' ? e : e?.target?.value || ''
    if (value === '') {
      setShowCustomSuggest(true)
      setFilteredIdentityList(identityList.slice(0, 5))
    } else {
      let exactMatches = identityList.filter((item) =>
        item.toLowerCase().startsWith(value.toLowerCase()),
      )

      let containsMatches = identityList.filter(
        (item) =>
          item.toLowerCase().includes(value.toLowerCase()) &&
          !exactMatches.includes(item),
      )

      let finalMatches = [...exactMatches, ...containsMatches].slice(0, 5)
      setFilteredIdentityList(finalMatches)
    }
  }

  const extractUserData = (userData) => {
    const browserHash =
      userData?.browserHash || localStorage.getItem('browserHash')
    const browserFingerPrint =
      userData?.browserFingerPrint || localStorage.getItem('browserFingerPrint')
    const browserCustomFingerPrint =
      userData?.browserCustomFingerPrint ||
      localStorage.getItem('browserCustomFingerPrint')

    if (!browserHash || !browserFingerPrint || !browserCustomFingerPrint) {
      throw new Error(
        'Browser data not available, need to fetch client data first',
      )
    }

    return {
      browserHash,
      browserFingerPrint,
      browserCustomFingerPrint,
    }
  }

  const fetchOtp = async (status) => {
    try {
      setIsFetchingOtp(true)

      let browserData
      try {
        browserData = extractUserData(userData)
      } catch (error) {
        await fetchClientData()
        browserData = extractUserData(userData)
      }

      const res5 = await sendOtp({
        identity: payload?.identity,
        deviceHash: hash ? hash : null,
        type: status,
        channel: validateEmail(payload?.identity) ? 'EMAIL' : 'WHATSAPP',
        ...browserData,
        'g-recaptcha-response': await recaptcha(),
      })

      if (res5?.data?.meta?.error || res5?.error?.data?.meta?.error) {
        enqueueSnackbar(
          res5?.data?.meta?.message ??
          res5?.data?.message ??
          res5?.error?.data?.meta?.message ??
          'Terjadi kesalahan.',
          {
            variant: 'error',
          },
        )
        return
      } else {
        navigate('/otp', {
          state: {
            type: validateEmail(payload?.identity) ? 'email' : 'phone',
            identity: payload?.identity,
            deviceHash: hash ? hash : null,
            countDown: res5?.data?.data?.expireTime,
            ...browserData,
            status: status,
            fcmToken: fcmToken ?? '',
            mobileVersion: mobileVersion ?? '',
            packageName: packageName ?? '',
          },
        })
      }
    } catch (error) {
      enqueueSnackbar(
        error?.data?.meta?.message ??
        error?.data?.message ??
        error?.error?.data?.meta?.message ??
        'Terjadi kesalahan.',
        {
          variant: 'error',
        },
      )
    } finally {
      setIsFetchingOtp(false)
    }
  }

  const handleSubmit = async () => {
    try {
      let browserData
      try {
        browserData = extractUserData(userData)
      } catch (error) {
        await fetchClientData()
        browserData = extractUserData(userData)
      }

      const res = await preCheck({
        identity: payload?.identity,
        'g-recaptcha-response': await recaptcha(),
        ...browserData,
      })

      if (res.error) throw res
      setUserData((prevState) => ({ ...prevState, ...res?.data?.data }))
      savePhoneNumberToLocalStorage(payload?.identity)
      handleNavigation(res?.data?.data)
    } catch (error) {
      handleError(error)
    }
  }

  useEnterSubmit(handleSubmit, !payload?.identity)

  const handleNavigation = (data) => {
    if (data?.sendOtp && data?.allow) {
      if (data?.status === 'REGISTERED') {
        if (data?.updatePassword) {
          fetchOtp('updatePassword')
        } else {
          navigate(URL_LOGIN_PASSWORD, {
            state: {
              type: validateEmail(payload?.identity) ? 'email' : 'phone',
              identity: payload?.identity,
              deviceHash: hash || null,
              fcmToken: fcmToken ?? '',
              mobileVersion: mobileVersion ?? '',
              packageName: packageName ?? '',
              ...extractUserData(userData),
              ...data,
            },
          })
        }
      } else {
        setShowRegistModal({ modal: true, otp: true })
      }
    } else if (!data?.sendOtp && !data?.sendDeviceInfo && data?.allow) {
      navigate(
        data?.status === 'REGISTERED' && !data?.updatePassword
          ? URL_LOGIN_PASSWORD
          : '/register',
        {
          state: {
            type: validateEmail(payload?.identity) ? 'email' : 'phone',
            identity: payload?.identity,
            deviceHash: hash || null,
            fcmToken: fcmToken ?? '',
            mobileVersion: mobileVersion ?? '',
            packageName: packageName ?? '',
            ...extractUserData(userData),
            ...data,
          },
        },
      )
    }
  }

  const handleError = (error) => {
    fetchClientData()
    console.error(error)
    enqueueSnackbar(
      error?.error?.data?.meta?.message ??
      error?.data?.meta?.message ??
      error?.data?.message ??
      'Terjadi kesalahan.',
      {
        variant: 'error',
      },
    )
  }

  const fetchClientData = async () => {
    const client = new ClientJS()
    const clientData = getClientData(client)

    const dataForHash = {
      fingerprint: clientData.getFingerprint,
      customFingerprint: clientData.getCustomFingerprint,
    }

    clientData.hash = generateHash(dataForHash)
    await handleCheckDevice(clientData)
  }

  const getClientData = (client) => {
    const methods = Object.getOwnPropertyNames(
      Object.getPrototypeOf(client),
    ).filter(
      (method) =>
        typeof client[method] === 'function' && method !== 'constructor',
    )

    const keysToRemove = new Set([
      'getCPU',
      'getBrowserVersion',
      'getUserAgentLowerCase',
      'isMobileIOS',
      'isIphone',
      'getDeviceType',
      'getUserAgent',
      'isChrome',
      'isFirefox',
      'isIphone',
      'isIpod',
      'isMac',
      'isMobile',
      'isMobileBlackBerry',
      'isMobileMajor',
      'isMobileOpera',
      'isMobileSafari',
      'isMobileWindows',
      'isOpera',
      'isSafari',
      'isUbuntu',
      'isWindows',
      'isIpad',
      'isJava',
      'isLinux',
      'isSolaris',
      'isIE',
      'isMobileAndroid',
      'isFont',
    ])

    return methods.reduce((acc, method) => {
      if (!keysToRemove.has(method)) {
        try {
          acc[method] = client[method]()
        } catch (error) {
          acc[method] = `Error: ${error.message}`
        }
      }
      return acc
    }, {})
  }

  const generateHash = (data) => {
    const combinedFingerprint = `${data.fingerprint}${data.customFingerprint}`
    return uuidv5(combinedFingerprint, uuidv4()).replace(/-/g, '')
  }

  const handleCheckDevice = async (data) => {
    let storedData = getStoredBrowserData()

    if (
      !storedData.browserHash ||
      !storedData.browserFingerPrint ||
      !storedData.browserCustomFingerPrint
    ) {
      storedData = setNewBrowserData(data)
    }

    try {
      const res = hash
        ? await checkDeviceV1({ deviceHash: hash })
        : await checkDeviceV2({
          ...storedData,
          'g-recaptcha-response': await recaptcha(),
        })

      if (isMatchingDevice(res?.data?.data, storedData)) {
        setUserData({
          ...res?.data?.data,
          browserHash: storedData.browserHash,
          browserFingerPrint: storedData.browserFingerPrint,
          browserCustomFingerPrint: storedData.browserCustomFingerPrint,
        })
      } else {
        const resCreate = await createDevice({
          ...storedData,
          'g-recaptcha-response': await recaptcha(),
          deviceToken: data?.hash,
          deviceInfo: { browserInfo: data },
          ...(hash && { deviceHash: hash }),
          packageName: packageName || localStorage.getItem('PMB_packageName') || null,
        })

        setUserData({
          ...resCreate?.data?.data,
          browserHash: storedData.browserHash,
          browserFingerPrint: storedData.browserFingerPrint,
          browserCustomFingerPrint: storedData.browserCustomFingerPrint,
        })
      }
    } catch (error) {
      handleError(error)
    }
  }

  const getStoredBrowserData = () => ({
    browserHash: localStorage.getItem('browserHash') || null,
    browserFingerPrint: localStorage.getItem('browserFingerPrint') || null,
    browserCustomFingerPrint:
      localStorage.getItem('browserCustomFingerPrint') || null,
  })

  const setNewBrowserData = (data) => {
    const newHash = uuidv4().replace(/-/g, '')
    localStorage.setItem('browserHash', newHash)
    localStorage.setItem('browserFingerPrint', data?.getFingerprint)
    localStorage.setItem('browserCustomFingerPrint', data?.getCustomFingerprint)
    return {
      browserHash: newHash,
      browserFingerPrint: data?.getFingerprint,
      browserCustomFingerPrint: data?.getCustomFingerprint,
    }
  }

  const isMatchingDevice = (serverData, localData) => {
    return (
      serverData?.browserCustomFingerPrint ===
      localData?.browserCustomFingerPrint &&
      serverData?.browserFingerPrint === localData?.browserFingerPrint &&
      serverData?.browserHash === localData?.browserHash
    )
  }

  useEffect(() => {
    const storedNumbers = JSON.parse(localStorage.getItem('phoneNumbers')) || []
    setSuggestions(storedNumbers)
  }, [])

  useEffect(() => {
    if (token) {
      if (searchParams.get('email')) {
        dispatch(logout())
      } else {
        // window.location.replace('/homepage')
        window.location.replace('/')
      }
    }
  }, [token, dispatch])

  const inputRef = useRef(null)
  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 100)
  }, [])

  useEffect(() => {
    setIsEmail(checkInputType(payload?.identity))
  }, [payload?.identity])

  useEffect(() => {
    const emailFromURL = searchParams.get('email')
    if (emailFromURL) {
      setPayload({ identity: decodeURIComponent(emailFromURL) })
      setIsOnboard(true)
    }
  }, [])

  useEffect(() => {
    const checkBrowserData = () => {
      const hasAllData =
        localStorage.getItem('browserHash') &&
        localStorage.getItem('browserFingerPrint') &&
        localStorage.getItem('browserCustomFingerPrint')

      if (
        !hasAllData &&
        (!userData?.browserHash ||
          !userData?.browserFingerPrint ||
          !userData?.browserCustomFingerPrint)
      ) {
        fetchClientData()
      }
    }

    checkBrowserData()
  }, [])

  return (
    <div className="centered-container">
      {/* Konten Utama */}
      <div
        className="w-100 card-wrapper"
        style={{
          borderRadius: 10,
          maxWidth: '600px',
        }}
      >
        <img
          src={getMetaContent('og:image')}
          alt={`${getMetaContent('og:title')} logo`}
          style={{
            marginBottom: 24,
            width: '100%',
            maxWidth: '150px',
            height: 'auto',
          }}
        />

        <P>Masuk atau daftar di sini</P>
        {(() => {
          const FormTag = !isMobile ? 'form' : 'div'
          const formProps = !isMobile
            ? {
                onSubmit: async (e) => {
                  e.preventDefault()
                  if (
                    payload?.identity &&
                    !loading &&
                    !isLoadingPreCheck &&
                    !isLoadingSendOTP
                  ) {
                    try {
                      setLoading(true)
                      await fetchClientData()
                      await new Promise((resolve) => setTimeout(resolve, 100))
                      await handleSubmit()
                    } catch (error) {
                      //
                    } finally {
                      setLoading(false)
                    }
                  }
                },
              }
            : {}

          return (
            <FormTag {...formProps}>
              <div style={{ marginTop: '20px' }}>
                <P size="regular">Email atau nomor telepon</P>
                <Input
                  innerRef={inputRef}
                  type="text"
                  name={!isMobile ? 'username' : 'identity_no_autofill'}
                  id={!isMobile ? 'username' : 'identity_no_autofill'}
                  className="mt-2"
                  placeholder="Masukkan email atau nomor telepon"
                  autoComplete={!isMobile ? 'username' : 'off'}
                  autoCorrect={isMobile ? 'off' : undefined}
                  autoCapitalize={isMobile ? 'off' : undefined}
                  spellCheck={isMobile ? false : undefined}
                  data-1p-ignore={isMobile ? 'true' : undefined}
                  data-bwignore={isMobile ? 'true' : undefined}
                  data-testid="login-universal-identity-input"
                  style={{ fontSize: '14px' }}
                  onChange={(e) => {
                    const val = e?.target?.value ?? ''
                    handleInputChange(val)
                    setPayload((prevState) => ({
                      ...prevState,
                      identity: val,
                    }))
                    if (!val || val.trim() === '') {
                      setShowCustomSuggest(true)
                    }
                  }}
                  value={payload?.identity ?? ''}
                  onFocus={() => {
                    setIsFocused(true)
                    setShowCustomSuggest(true)
                  }}
                  onClick={() => {
                    setShowCustomSuggest(true)
                  }}
                  onBlur={() => setTimeout(() => setIsFocused(false), 200)}
                  onKeyDown={(e) => {
                    if (e.key === 'ArrowDown') {
                      setShowCustomSuggest(false)
                    }
                    if (
                      e.key === 'Enter' &&
                      payload?.identity &&
                      !isLoadingPreCheck &&
                      !isLoadingSendOTP
                    ) {
                      handleSubmit()
                    }
                  }}
                  disabled={isOnboard}
                />

                {!isMobile && (
                  <input
                    type="password"
                    name="password"
                    style={{
                      display: 'none',
                      position: 'absolute',
                      opacity: 0,
                      height: 0,
                      width: 0,
                    }}
                    tabIndex={-1}
                    autoComplete="current-password"
                    readOnly
                  />
                )}

                {isMobile &&
                  isFocused &&
                  showCustomSuggest &&
                  filteredIdentityList?.length > 0 && (
                    <div className="suggestion-container">
                      {filteredIdentityList?.map((suggestion, index) => (
                        <div
                          key={index}
                          data-testid={`login-universal-suggestion-${index}`}
                          onMouseDown={(e) => {
                            e.preventDefault()
                            setPayload((prevState) => ({
                              ...prevState,
                              identity: suggestion,
                            }))
                            handleInputChange(suggestion)
                            setShowCustomSuggest(false)
                          }}
                          onTouchStart={(e) => {
                            e.preventDefault()
                            setPayload((prevState) => ({
                              ...prevState,
                              identity: suggestion,
                            }))
                            handleInputChange(suggestion)
                            setShowCustomSuggest(false)
                          }}
                        >
                          <p className="suggestion-item">{suggestion}</p>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
              <div className="w-100 mt-3">
                <Button
                  type={!isMobile ? 'submit' : 'button'}
                  disabled={
                    !payload?.identity ||
                    loading ||
                    isLoadingPreCheck ||
                    isLoadingSendOTP
                  }
                  className="w-100 d-flex justify-content-center align-items-center"
                  color="primary"
                  data-testid="login-universal-submit-button"
                  onClick={async () => {
                    if (isMobile) {
                      try {
                        setLoading(true)
                        await fetchClientData()
                        await new Promise((resolve) => setTimeout(resolve, 100))
                        await handleSubmit()
                      } catch (error) {
                        //
                      } finally {
                        setLoading(false)
                      }
                    }
                  }}
                >
                  {(loading || isLoadingPreCheck || isLoadingSendOTP) && (
                    <Spinner className="me-2" size="sm" color="light" />
                  )}
                  <P size="regular">Masuk</P>
                </Button>
              </div>
            </FormTag>
          )
        })()}

        <div className="d-flex align-items-center justify-content-center mt-3">
          <div style={{ flex: 1, height: '1px', backgroundColor: '#E4E7EC' }} />
          <P size="small" style={{ margin: '0 12px', color: '#667085' }}>Atau</P>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#E4E7EC' }} />
        </div>

        <div className="w-100 mt-3">
          <Button
            className="w-100 d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: '#FFF',
              borderColor: '#D0D5DD',
              color: '#344054',
              gap: '8px'
            }}
            onClick={() => {
              if (noCsPasmik) {
                window.open(`https://wa.me/${noCsPasmik}?text=Saya%20hendak%20login%20ke%20PasarMIKRO`, '_blank')
              }
            }}
            disabled={!noCsPasmik}
            data-testid="login-universal-whatsapp-button"
          >
            <img src={whatsApp} alt="WA" style={{ width: 24, height: 24 }} />
            <P size="regular" style={{ color: '#344054', fontWeight: 600 }}>Masuk dengan WhatsApp</P>
          </Button>
        </div>

        <div className="d-flex gap-2 mt-4" style={{ justifyContent: 'center' }}>
          <P size="regular">Butuh bantuan? </P>
          <div style={{ cursor: 'pointer' }}>
            <P
              size="regular"
              color={'#006386'}
              onClick={() => {
                if (noCsPasmik) {
                  window.open(`https://wa.me/${noCsPasmik}`, '_blank')
                }
              }}
              style={{ cursor: 'pointer' }}
              disabled={!noCsPasmik}
              testId="login-universal-contact-cs-link"
            >
              Hubungi kami
            </P>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-100 text-center py-3">
        <Tnc />
      </footer>
      {renderModal()}
    </div>
  )

  function renderModal() {
    return (
      <>
        <div>
          <ResponsiveModal
            isOpen={isShowRegistModal?.modal}
            isMobile={isMobile}
            onPressRight={() => {
              fetchOtp(userData?.status === 'LOGIN' ? 'login' : 'registration')
            }}
            loading={isFetchingOtp}
            onPressLeft={() => setShowRegistModal({ modal: false })}
            isEmail={isEmail}
          />
        </div>
      </>
    )
  }
}

export default Login
